import "./App.css";
import { useLayoutEffect, useEffect, useState } from "react";
import { Header } from "./components/Layout/Header";
import { Routes } from "./Routes";
import { RouterProvider } from "react-router-dom";
import { useUserData } from "./hooks/useUserData";
import { APP_SETTINGS } from "./hooks/useAppSettings";

function App() {
  // Make sure to call `loadStripe` outside of a component’s render to avoid
  // recreating the `Stripe` object on every render.
  const { setToken, setIsAuthenticated, setLang } = useUserData();

  useEffect(() => {
    //ONLY FOR DEV PURPOSES START
    /*setIsAuthenticated(true);
    setToken({
      access_token: "KIYcK4OlbCohbwL0pUHZnhgKCOBJM8W8y3u6LpmRL7dcfVrms9fR1hpjNNUXpEPuhoktH9eYUQ_Uklh9Mi6sbfBitPnvjwtxo6fJh1jVb-RA79rHa7O4j8-5EdhmDwEqqGQSbwhuaiOMFSD6mkNFzO1I8vWTmiE2pGKLEnsJvl31wPac765MdlWkTH8JMxVSuKLVI4b1KlDIsFdCqJ5tg2e-PE3LNsPI0r0Xn9iAGEY5Lsdk9Z-J-odMhN20e5ry-GnLtRSy9ufWCYBpdiwHriGkiq3XU6n0eoHkdk2XEP9zIoP_iz1AnUDwyBkMb-FbP6bciyBTk12ktSnwghEvIMkuGf5vrpumQEuMAJjH1e8"
      ,expires_on:  1209599
    });*/
    //ONLY FOR DEV PURPOSES END
    const tokenIn = localStorage.getItem("token");
    if (tokenIn != null) {
      const expirationDate = localStorage.getItem("token_expires_on");
      const secondsFromNow = expirationDate; // Duration in seconds from now
      const now = Date.now(); // Current timestamp in milliseconds
      const futureDate = new Date(now + secondsFromNow * 1000); // Calculate the future date

      if (futureDate > Date.now()) {
        setIsAuthenticated(true);
        setToken({
          access_token: tokenIn,
          expires_on: expirationDate,
        });
      }
    }
  }, []);

  //Load language
  useLayoutEffect(() => {
    //window.lang = "it";
    let globalLang = localStorage.getItem('lang') == null ? 'en' : localStorage.getItem('lang');
    
    const loadLanguage = async () => {
      switch (globalLang) {
        case "it":
          var jsonFile = await fetch(
            APP_SETTINGS.url + APP_SETTINGS.languagesFiles.it
          );
          var result = await jsonFile.json();
          setLang(result);
          break;
        case "en":
          var jsonFile = await fetch(
            APP_SETTINGS.url + APP_SETTINGS.languagesFiles.en
          );
          var result = await jsonFile.json();
          setLang(result);

          break;
        default:
          var jsonFile = await fetch(
            APP_SETTINGS.url + APP_SETTINGS.languagesFiles.en
          );
          var result = await jsonFile.json();
          setLang(result);
          break;
      }
    };
    loadLanguage();
  }, [window?.lang]);

  return (
    <>
      <Header></Header>
      <RouterProvider router={Routes}></RouterProvider>
    </>
  );
}

export default App;
